import { constants, typographyStyles } from "@newsela/angelou";
const { heading3Obj } = typographyStyles;
const greyLight = constants.colors.ui.neutral[300];

export const itemGridLayoutCss = {
  display: "grid",
  gridTemplateColumns: "repeat(100, minmax(250px, 1fr))",
  gridAutoRows: "392px",
  gridGap: "30px",
  gridAutoFlow: "column",
  listStyleType: "none",
  padding: 0,
};

export const activitiesStepCss = {
  display: "flex",
  flexFlow: "row nowrap",
  justifyContent: "space-between",
  borderBottom: `2px solid ${greyLight}`,
  marginBottom: "26px",
  paddingBottom: "8px",
};

export const activitiesStepTitleCss = [
  {
    paddingTop: ".75rem",
  },
  heading3Obj,
];
